import React, { useCallback } from 'react';

import { UI_EVENT_TYPE } from '@atlaskit/analytics-gas-types';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { FlyoutTrigger } from '@atlassian/entry-point-flyout';

import { EVENT_CHANNEL } from '../../common/analytics/constants';

import { objectListFlyoutEntrypoint } from './flyout-menu-item-content/entrypoint';
import type { ObjectListFlyoutProps } from './types';

/**
 * Component that renders a list of items in a flyout menu with searching & filtering capabilities in the list.
 * Consumers can provide the items data via the useItems hook.
 */
export function ObjectListFlyout(props: ObjectListFlyoutProps) {
	const { label, icon, analyticsName, triggerRef, testId } = props;
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleTriggerClick = useCallback(() => {
		createAnalyticsEvent({
			eventType: UI_EVENT_TYPE,
			action: 'clicked',
			actionSubject: 'globalNavigation',
			actionSubjectId: 'objectListFlyoutTrigger',
			attributes: {
				name: analyticsName,
				component: 'ObjectListFlyout',
			},
		}).fire(EVENT_CHANNEL);
	}, [createAnalyticsEvent, analyticsName]);

	return (
		<FlyoutTrigger
			entryPoint={objectListFlyoutEntrypoint}
			entryPointProps={props}
			triggerProps={{
				elemBefore: icon,
				onClick: handleTriggerClick,
				children: label,
				testId,
				triggerRef,
			}}
		/>
	);
}
